"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "valfornace": {
    "petrignano": [{
      "hkey": "4c55f25b",
      "slug": "valfornace",
      "name": "Valfornace",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "47386f79": [{
      "hkey": "4c55f25b",
      "slug": "valfornace",
      "name": "Valfornace",
      "primary": true,
      "skipSearch": false
    }],
    "taro": [{
      "hkey": "4c55f25b",
      "slug": "valfornace",
      "name": "Valfornace",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bd592c15": [{
      "hkey": "d9453710",
      "slug": "fiordimonte",
      "name": "Fiordimonte",
      "primary": true,
      "skipSearch": false
    }],
    "valle": [{
      "hkey": "d9453710",
      "slug": "fiordimonte",
      "name": "Fiordimonte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "valfornace"
    }],
    "c7dd67ac": [{
      "hkey": "d9453710",
      "slug": "fiordimonte",
      "name": "Fiordimonte",
      "primary": true,
      "skipSearch": false
    }],
    "vico-di-sopra": [{
      "hkey": "d9453710",
      "slug": "fiordimonte",
      "name": "Fiordimonte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "valfornace"
    }],
    "be405ba3": [{
      "hkey": "d9453710",
      "slug": "fiordimonte",
      "name": "Fiordimonte",
      "primary": true,
      "skipSearch": false
    }],
    "vico-di-sotto": [{
      "hkey": "d9453710",
      "slug": "fiordimonte",
      "name": "Fiordimonte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "valfornace"
    }],
    "ca7444ba": [{
      "hkey": "d9453710",
      "slug": "fiordimonte",
      "name": "Fiordimonte",
      "primary": true,
      "skipSearch": false
    }],
    "villanova-di-sotto": [{
      "hkey": "d9453710",
      "slug": "fiordimonte",
      "name": "Fiordimonte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "valfornace"
    }],
    "ce8974d1": [{
      "hkey": "d9453710",
      "slug": "fiordimonte",
      "name": "Fiordimonte",
      "primary": true,
      "skipSearch": false
    }],
    "villanovadi-sopra": [{
      "hkey": "d9453710",
      "slug": "fiordimonte",
      "name": "Fiordimonte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "valfornace"
    }],
    "cb563a76": [{
      "hkey": "d9453710",
      "slug": "fiordimonte",
      "name": "Fiordimonte",
      "primary": true,
      "skipSearch": false
    }],
    "alfi": [{
      "hkey": "d9453710",
      "slug": "fiordimonte",
      "name": "Fiordimonte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "valfornace"
    }],
    "ca8fd722": [{
      "hkey": "4c55f25b",
      "slug": "valfornace",
      "name": "Valfornace",
      "primary": true,
      "skipSearch": false
    }],
    "arciano": [{
      "hkey": "4c55f25b",
      "slug": "valfornace",
      "name": "Valfornace",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d8b6096d": [{
      "hkey": "4c55f25b",
      "slug": "valfornace",
      "name": "Valfornace",
      "primary": true,
      "skipSearch": false
    }],
    "castello": [{
      "hkey": "4c55f25b",
      "slug": "valfornace",
      "name": "Valfornace",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "24b122ea": [{
      "hkey": "4c55f25b",
      "slug": "valfornace",
      "name": "Valfornace",
      "primary": true,
      "skipSearch": false
    }],
    "marzoli": [{
      "hkey": "4c55f25b",
      "slug": "valfornace",
      "name": "Valfornace",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8a99e926": [{
      "hkey": "d9453710",
      "slug": "fiordimonte",
      "name": "Fiordimonte",
      "primary": true,
      "skipSearch": false
    }],
    "nemi": [{
      "hkey": "d9453710",
      "slug": "fiordimonte",
      "name": "Fiordimonte",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "valfornace"
    }],
    "1bff697e": [{
      "hkey": "4c55f25b",
      "slug": "valfornace",
      "name": "Valfornace",
      "primary": true,
      "skipSearch": false
    }]
  }
};
exports["default"] = _default;